import { api } from './client';
import type { UserBriefDto, UserDto } from './types';

/** Краткий профиль любого пользователя — для просмотра карточки участника группы. */
export function getUserBrief(id: string): Promise<UserBriefDto> {
  return api<UserBriefDto>(`/api/v1/users/${id}`);
}

export function changePassword(oldPassword: string, newPassword: string) {
  return api('/api/v1/users/me/password', {
    method: 'PATCH',
    body: JSON.stringify({ oldPassword, newPassword }),
  });
}

/** fileId — id уже загруженного через uploadMedia() файла-картинки; null — сбросить аватар. */
export function setAvatar(fileId: string | null): Promise<UserDto> {
  return api<UserDto>('/api/v1/users/me/avatar', {
    method: 'PATCH',
    body: JSON.stringify({ fileId }),
  });
}

/** Описание профиля (до 200 символов, с эмодзи). bio='' — сбросить. */
export function setBio(bio: string | null): Promise<UserDto> {
  return api<UserDto>('/api/v1/users/me/bio', {
    method: 'PATCH',
    body: JSON.stringify({ bio }),
  });
}

/** Отображаемое имя. Логин (username) не редактируется намеренно. */
export function setDisplayName(displayName: string): Promise<UserDto> {
  return api<UserDto>('/api/v1/users/me/display-name', {
    method: 'PATCH',
    body: JSON.stringify({ displayName }),
  });
}

/** email/phone — каждый опционален по отдельности, но хотя бы один должен остаться заполненным. */
export function setContact(email: string | null, phone: string | null): Promise<UserDto> {
  return api<UserDto>('/api/v1/users/me/contact', {
    method: 'PATCH',
    body: JSON.stringify({ email, phone }),
  });
}

/** ISO-дата (ГГГГ-ММ-ДД). birthDate=null — сбросить. */
export function setBirthDate(birthDate: string | null): Promise<UserDto> {
  return api<UserDto>('/api/v1/users/me/birth-date', {
    method: 'PATCH',
    body: JSON.stringify({ birthDate }),
  });
}

/** Показывать дату рождения контактам (баннер дня рождения в списке чатов) — opt-in. */
export function setShowBirthDateToContacts(enabled: boolean): Promise<UserDto> {
  return api<UserDto>('/api/v1/users/me/birth-date-visibility', {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });
}

/** Показывать самому баннер о днях рождения контактов. */
export function setNotifyBirthdays(enabled: boolean): Promise<UserDto> {
  return api<UserDto>('/api/v1/users/me/birthday-notifications', {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });
}

/** Тип сообщения по умолчанию для кнопки записи в композере — 'voice' или 'video'. */
export function setDefaultRecordType(type: 'voice' | 'video'): Promise<UserDto> {
  return api<UserDto>('/api/v1/users/me/default-record-type', {
    method: 'PATCH',
    body: JSON.stringify({ type }),
  });
}

/** Отправлять другим статусы прочтения (выключивший не видит и чужие). */
export function setReadReceipts(enabled: boolean): Promise<UserDto> {
  return api<UserDto>('/api/v1/users/me/read-receipts', {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });
}

export function setNewChatsMutedByDefault(enabled: boolean): Promise<UserDto> {
  return api<UserDto>('/api/v1/users/me/new-chats-muted-default', {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });
}
